export const SERVER_ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25, 50, 100];
export const EXTENDED_SERVER_ROWS_PER_PAGE_OPTIONS = [...SERVER_ROWS_PER_PAGE_OPTIONS, 200];
